window.customSort = function(sortName, sortOrder, data)
{
    let order = sortOrder === 'desc' ? -1 : 1
    if(sortName == 'Period'){
        data.sort(function (a, b) {
            a = a.Period.replace('-', ' ').split(' ');
            b = b.Period.replace('-', ' ').split(' ');
            let periodOne = a[1] + a[0];
            let periodTwo = b[1] + b[0];

            if (periodOne > periodTwo)
            {
                return order;
            }    
            if (periodOne < periodTwo) 
            {
                return order * -1;
            }  

            
            return 0;
        })
    }else{
        data.sort(function (a, b) {
            let aa = +((a[sortName] + '').replace(/[^\d]/g, ''));
            let bb = +((b[sortName] + '').replace(/[^\d]/g, ''));
            if (aa < bb) {
                return order * -1;
            }
            if (aa > bb) {
                return order;
            }

            return 0;
        })
    }

}